import { GoogleGenAI } from "@google/genai";

// Helper to check standard React/Vite env var patterns safely
const getEnv = (key: string) => {
  if (typeof process !== 'undefined' && process.env) {
    return process.env[key];
  }
  try {
     // @ts-ignore
     if (typeof import.meta !== 'undefined' && import.meta.env) {
        // @ts-ignore
        return import.meta.env[key] || import.meta.env[`VITE_${key}`];
     }
  } catch(e) {}
  return undefined;
};

const apiKey = getEnv('API_KEY'); 
let aiClient: GoogleGenAI | null = null;

if (apiKey) {
  aiClient = new GoogleGenAI({ apiKey });
}

export const categorizeActivity = async (note: string): Promise<string> => {
  if (!apiKey || !aiClient) {
    console.warn("Gemini API Key missing. Skipping categorization.");
    return "General";
  }

  try {
    const prompt = `
      Analyze the following productivity log note and assign it a single category (maximum 2 words).
      Examples: "Coding", "Meeting", "Reading", "Social Media", "Rest", "Exercise", "Study".
      
      Note: "${note}"
      
      Category:
    `;

    const response = await aiClient.models.generateContent({
      model: 'gemini-2.5-flash',
      contents: prompt,
    });

    const text = response.text;
    return text ? text.trim().replace(/['"]/g, '') : "General";
  } catch (error) {
    console.error("Gemini categorization failed:", error);
    return "Uncategorized";
  }
};